'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = function (_ref) {
  var thick = _ref.thick,
      thin = _ref.thin,
      type = _ref.type;

  switch (type) {
    case 'alarm':
      return !thick && !thin ? _react2.default.createElement('span', null, "\uDA44\uDC00") : thick ? _react2.default.createElement('span', null, "\uDA84\uDC00") : _react2.default.createElement('span', null, "\uDAC4\uDC00");

    case 'angle':
      return !thick && !thin ? _react2.default.createElement('span', null, "\uDA44\uDC01") : thick ? _react2.default.createElement('span', null, "\uDA84\uDC01") : _react2.default.createElement('span', null, "\uDAC4\uDC01");

    case 'arrow':
      return !thick && !thin ? _react2.default.createElement('span', null, "\uDA44\uDC02") : thick ? _react2.default.createElement('span', null, "\uDA84\uDC02") : _react2.default.createElement('span', null, "\uDAC4\uDC02");

    case 'bar-chart':
      return !thick && !thin ? _react2.default.createElement('span', null, "\uDA44\uDC03") : thick ? _react2.default.createElement('span', null, "\uDA84\uDC03") : _react2.default.createElement('span', null, "\uDAC4\uDC03");

    case 'calendar':
      return !thick && !thin ? _react2.default.createElement('span', null, "\uDA44\uDC04") : thick ? _react2.default.createElement('span', null, "\uDA84\uDC04") : _react2.default.createElement('span', null, "\uDAC4\uDC04");

    case 'call':
      return !thick && !thin ? _react2.default.createElement('span', null, "\uDA44\uDC05") : thick ? _react2.default.createElement('span', null, "\uDA84\uDC05") : _react2.default.createElement('span', null, "\uDAC4\uDC05");

    case 'caution':
      return !thick && !thin ? _react2.default.createElement('span', null, "\uDA44\uDC30") : thick ? _react2.default.createElement('span', null, "\uDA84\uDC30") : _react2.default.createElement('span', null, "\uDAC4\uDC30");

    case 'chat':
      return !thick && !thin ? _react2.default.createElement('span', null, "\uDA44\uDC06") : thick ? _react2.default.createElement('span', null, "\uDA84\uDC06") : _react2.default.createElement('span', null, "\uDAC4\uDC06");

    case 'check':
      return !thick && !thin ? _react2.default.createElement('span', null, "\uDA44\uDC07") : thick ? _react2.default.createElement('span', null, "\uDA84\uDC07") : _react2.default.createElement('span', null, "\uDAC4\uDC07");

    case 'checkered-flag':
      return !thick && !thin ? _react2.default.createElement('span', null, "\uDA44\uDC08") : thick ? _react2.default.createElement('span', null, "\uDA84\uDC08") : _react2.default.createElement('span', null, "\uDAC4\uDC08");

    case 'cog':
      return !thick && !thin ? _react2.default.createElement('span', null, "\uDA44\uDC09") : thick ? _react2.default.createElement('span', null, "\uDA84\uDC09") : _react2.default.createElement('span', null, "\uDAC4\uDC09");

    case 'data-table':
      return !thick && !thin ? _react2.default.createElement('span', null, "\uDA44\uDC29") : thick ? _react2.default.createElement('span', null, "\uDA84\uDC29") : _react2.default.createElement('span', null, "\uDAC4\uDC29");

    case 'document':
      return !thick && !thin ? _react2.default.createElement('span', null, "\uDA44\uDC10") : thick ? _react2.default.createElement('span', null, "\uDA84\uDC10") : _react2.default.createElement('span', null, "\uDAC4\uDC10");

    case 'download':
      return !thick && !thin ? _react2.default.createElement('span', null, "\uDA44\uDC33") : thick ? _react2.default.createElement('span', null, "\uDA44\uDC33") : _react2.default.createElement('span', null, "\uDA44\uDC33");

    case 'expand':
      return !thick && !thin ? _react2.default.createElement('span', null, "\uDA44\uDC11") : thick ? _react2.default.createElement('span', null, "\uDA84\uDC11") : _react2.default.createElement('span', null, "\uDAC4\uDC11");

    case 'file':
      return !thick && !thin ? _react2.default.createElement('span', null, "\uDA44\uDC12") : thick ? _react2.default.createElement('span', null, "\uDA84\uDC12") : _react2.default.createElement('span', null, "\uDAC4\uDC12");

    case 'glasses':
      return !thick && !thin ? _react2.default.createElement('span', null, "\uDA44\uDC13") : thick ? _react2.default.createElement('span', null, "\uDA84\uDC13") : _react2.default.createElement('span', null, "\uDAC4\uDC13");

    case 'location':
      return !thick && !thin ? _react2.default.createElement('span', null, "\uDA44\uDC14") : thick ? _react2.default.createElement('span', null, "\uDA84\uDC14") : _react2.default.createElement('span', null, "\uDAC4\uDC14");

    case 'locked':
      return !thick && !thin ? _react2.default.createElement('span', null, "\uDA44\uDC32") : thick ? _react2.default.createElement('span', null, "\uDA84\uDC32") : _react2.default.createElement('span', null, "\uDAC4\uDC32");

    case 'magnifying-glass':
      return !thick && !thin ? _react2.default.createElement('span', null, "\uDA44\uDC15") : thick ? _react2.default.createElement('span', null, "\uDA84\uDC15") : _react2.default.createElement('span', null, "\uDAC4\uDC15");

    case 'megaphone':
      return !thick && !thin ? _react2.default.createElement('span', null, "\uDA44\uDC16") : thick ? _react2.default.createElement('span', null, "\uDA84\uDC16") : _react2.default.createElement('span', null, "\uDAC4\uDC16");

    case 'message':
      return !thick && !thin ? _react2.default.createElement('span', null, "\uDA44\uDC17") : thick ? _react2.default.createElement('span', null, "\uDA84\uDC17") : _react2.default.createElement('span', null, "\uDAC4\uDC17");

    case 'minus':
      return !thick && !thin ? _react2.default.createElement('span', null, "\uDA44\uDC18") : thick ? _react2.default.createElement('span', null, "\uDA84\uDC18") : _react2.default.createElement('span', null, "\uDAC4\uDC18");

    case 'money':
      return !thick && !thin ? _react2.default.createElement('span', null, "\uDA44\uDC19") : thick ? _react2.default.createElement('span', null, "\uDA84\uDC19") : _react2.default.createElement('span', null, "\uDAC4\uDC19");

    case 'pdf':
      return !thick && !thin ? _react2.default.createElement('span', null, "\uDA44\uDC20") : thick ? _react2.default.createElement('span', null, "\uDA84\uDC20") : _react2.default.createElement('span', null, "\uDAC4\uDC20");

    case 'pencil':
      return !thick && !thin ? _react2.default.createElement('span', null, "\uDA44\uDC21") : thick ? _react2.default.createElement('span', null, "\uDA84\uDC21") : _react2.default.createElement('span', null, "\uDAC4\uDC21");

    case 'person':
      return !thick && !thin ? _react2.default.createElement('span', null, "\uDA44\uDC22") : thick ? _react2.default.createElement('span', null, "\uDA84\uDC22") : _react2.default.createElement('span', null, "\uDAC4\uDC22");

    case 'pie-chart':
      return !thick && !thin ? _react2.default.createElement('span', null, "\uDA44\uDC23") : thick ? _react2.default.createElement('span', null, "\uDA84\uDC23") : _react2.default.createElement('span', null, "\uDAC4\uDC23");

    case 'plus':
      return !thick && !thin ? _react2.default.createElement('span', null, "\uDA44\uDC24") : thick ? _react2.default.createElement('span', null, "\uDA84\uDC24") : _react2.default.createElement('span', null, "\uDAC4\uDC24");

    case 'shovel':
      return !thick && !thin ? _react2.default.createElement('span', null, "\uDA44\uDC25") : thick ? _react2.default.createElement('span', null, "\uDA84\uDC25") : _react2.default.createElement('span', null, "\uDAC4\uDC25");

    case 'spreadsheet':
      return !thick && !thin ? _react2.default.createElement('span', null, "\uDA44\uDC26") : thick ? _react2.default.createElement('span', null, "\uDA84\uDC26") : _react2.default.createElement('span', null, "\uDAC4\uDC26");

    case 'trash-can':
      return !thick && !thin ? _react2.default.createElement('span', null, "\uDA44\uDC27") : thick ? _react2.default.createElement('span', null, "\uDA84\uDC27") : _react2.default.createElement('span', null, "\uDAC4\uDC27");

    case 'unlocked':
      return !thick && !thin ? _react2.default.createElement('span', null, "\uDA44\uDC31") : thick ? _react2.default.createElement('span', null, "\uDA84\uDC31") : _react2.default.createElement('span', null, "\uDAC4\uDC31");

    case 'x':
      return !thick && !thin ? _react2.default.createElement('span', null, "\uDA44\uDC28") : thick ? _react2.default.createElement('span', null, "\uDA84\uDC28") : _react2.default.createElement('span', null, "\uDAC4\uDC28");

    default:
      return null;
  }
};